export default function AboutSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <img 
              src="https://dtzulyujzhqiu.cloudfront.net/expcorporate377/images/1751568884_ipKGpLKSG6wC8CkwKAXm0RMA3CWEFVniRQ3UicN5.png" 
              alt="Jeffery Long" 
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>

          {/* Right Column - Content */}
          <div>
            <h2 className="text-3xl font-bold mb-6">About Jeffery Long</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              I'm a seasoned Commercial and Residential Real Estate Agent and Published Author with over 40 years of experience, beginning my career in land development in June 1980. I have a proven track record in building, repairing, selling, appraising, managing projects, and purchasing both commercial and residential properties, as well as various businesses.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              My expertise spans across multiple facets of real estate, including property management, investment strategies, and market analysis. I'm committed to providing exceptional service and leveraging my extensive experience to help clients achieve their real estate goals.
            </p>
            
            {/* Team Members */}
            <div className="mt-8">
              <h3 className="text-xl font-semibold mb-4">Meet Our Team</h3>
              <div className="grid grid-cols-3 gap-4">
                {[
                  { 
                    name: "Grace Dardano", 
                    dre: "DRE License #02371666",
                    image: "https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/94bf91b689e0252ebc70307a4c4dd1f9.png"
                  },
                  { 
                    name: "Gertrude Agbontaen", 
                    dre: "CA DRE# 02213397",
                    image: "https://public.readdy.ai/ai/img_res/151d1b4fc9656523bf47484dfb552a76.jpg"
                  },
                  { 
                    name: "Selena Aguilar", 
                    dre: "CA DRE# 02201461",
                    image: "https://readdy.ai/api/search-image?query=Professional%20young%20Latina%20woman%20real%20estate%20agent%20with%20shoulder-length%20brown%20hair%2C%20friendly%20smile%2C%20coral%20pink%20business%20blazer%2C%20energetic%20personality%2C%20clean%20white%20background&width=300&height=400&seq=selena-unique&orientation=portrait"
                  },
                  { 
                    name: "Marcus Chen", 
                    dre: "CA DRE# 02198745",
                    image: "https://readdy.ai/api/search-image?query=Professional%20young%20Asian%20American%20man%20real%20estate%20agent%20with%20short%20styled%20black%20hair%2C%20warm%20confident%20smile%2C%20tailored%20navy%20blue%20suit%20with%20white%20shirt%2C%20modern%20polished%20appearance%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=marcus-chen-agent&orientation=portrait"
                  },
                  { 
                    name: "Patricia Novak", 
                    dre: "CA DRE# 02245891",
                    image: "https://readdy.ai/api/search-image?query=Professional%20mature%20Caucasian%20woman%20real%20estate%20agent%20with%20auburn%20shoulder-length%20wavy%20hair%2C%20warm%20welcoming%20smile%2C%20teal%20business%20blazer%20over%20white%20blouse%2C%20elegant%20and%20approachable%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=patricia-novak-agent&orientation=portrait"
                  },
                  { 
                    name: "David Okafor", 
                    dre: "CA DRE# 02187634",
                    image: "https://readdy.ai/api/search-image?query=Professional%20African%20American%20man%20real%20estate%20agent%20with%20short%20fade%20haircut%2C%20bright%20friendly%20smile%2C%20dark%20charcoal%20suit%20with%20burgundy%20pocket%20square%2C%20confident%20and%20professional%20demeanor%2C%20clean%20white%20studio%20background%20portrait&width=300&height=400&seq=david-okafor-agent&orientation=portrait"
                  },
                  { 
                    name: "Kara Dukes", 
                    dre: "CA DRE# 02156789",
                    image: "https://static.readdy.ai/image/91f0f8e12b1f19026b27ce5c4f6b9182/3917fa49d44bb052e29aac644d8479cb.jpeg"
                  }
                ].map((member, index) => (
                  <div key={index} className="text-center">
                    <div className="w-20 h-20 mx-auto mb-3 rounded-full overflow-hidden bg-gray-200">
                      <img 
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <h4 className="font-medium text-sm mb-1">{member.name}</h4>
                    <p className="text-xs text-gray-600">{member.dre}</p>
                  </div>
                ))}
              </div>
              <div className="mt-6 text-center">
                <a href="/agents" className="text-sm font-semibold text-blue-600 hover:text-blue-800 cursor-pointer transition-colors inline-flex items-center gap-1">
                  View All 12 Team Members <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
